export default __webpack_public_path__ + "static/media/Band of Khan.8af18c13.jpg";